import React from 'react';
import { isArray } from 'lodash';
import { Theme } from '../../../theme';
import View from './View';
import Text from './Text';

interface FieldProps {
  label?: any;
  value?: any;
  labelProps?: any;
  [key: string]: any;
}

const Field = ({ label, value, labelProps, ...rest }: FieldProps) => {
  const isList = isArray(value);

  return (
    <View
      fontSize="12pt"
      alignItems={isList ? 'flex-start' : 'center'}
      flexDirection="row"
      mb={2}
      {...rest}
    >
      <View
        width="50pt"
        backgroundColor={Theme.colors.greyLighter}
        borderRight={`1pt solid ${Theme.colors.primary}`}
        mr={2}
        p="4pt"
        height="100%"
        justifyContent="center"
        {...labelProps}
      >
        <Text fontSize="10pt">{label}</Text>
      </View>
      {isList ? (
        <View>
          {value.map((item) => (
            <Text key={item}>{item}</Text>
          ))}
        </View>
      ) : (
        <View>
          <Text>{value || '-'}</Text>
        </View>
      )}
    </View>
  );
};

export default Field;
